export const OPERATOR_ROLE = ["EVENT_OPERATOR", "OPERATOR"];
